import NoSimIcon from "@mui/icons-material/NoSim";
import { GQLCameraStatus } from "@src/graphql.generated";
import Active from "@src/icons/Active";
import Inactive from "@src/icons/Inactive";
import theme from "@src/theme";
import { type ReactElement } from "react";

interface CameraStatusProps {
    status: GQLCameraStatus;
}

export const CameraStatus = ({ status }: CameraStatusProps): ReactElement => {
    if (status === GQLCameraStatus.Active) {
        return <Active htmlColor={theme.palette.success.main} />;
    }
    if (status === GQLCameraStatus.Sleep) {
        return <Inactive htmlColor={theme.palette.text.disabled} />;
    }

    return <NoSimIcon fontSize="large" htmlColor={theme.palette.error.main} />;
};
